import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import Avatar from '@components/avatar';
import { formatNumberToWan } from '@utils/formatNumber'
import { withRouter, RouteComponentProps } from 'react-router-dom';
interface PCSidebarUserInfoProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    userInfo?: any;
    publishType?: any;   //发布按钮类型，默认为1，类型是发图文
    topicId?: any;
    userClick?: Function;    // 头像点击事件
    loginClick?: Function;   // 登录按钮点击事件
    publishClick?: Function; // 发布按钮点击事件
    isShowUserDetail?: any  // 是否显示用户头像和昵称
    showOtherInfo?: boolean // 是否显示他人的用户信息
    otherUserInfo?: any  // 他人的用户信息数据
    isFeedback?: boolean    // 是否是问题反馈
}

@inject('app', 'site', 'user')
@observer
class PCSidebarUserInfo extends React.Component<PCSidebarUserInfoProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { user, userClick, loginClick, publishType, topicId = '', publishClick, isShowUserDetail = true, showOtherInfo, otherUserInfo, isFeedback = false } = this.props;
        const userInfo = (user?.userInfo as any) || {};
        let userData = showOtherInfo ? otherUserInfo : userInfo;
        const isLogin = !!userData?.code;
        // 标签示例：可根据实际接口调整
        // const tagList = userInfo.titleList || [];
        return <>
            <div className={styles.userInfoBox} onClick={() => {
            }}>
                {/* 已登录 */}
                {(isLogin || showOtherInfo) && <>
                    {isShowUserDetail && <div className={styles.userDetail}>
                        <Avatar
                            avatarUrl={userData?.avatarUrl || ''}
                            userClick={userClick}
                            titleMark={userData?.titleMark}
                            level={userData?.level}
                            size={50}
                            userCode={userData?.code}
                            officialSize={20}
                        />
                        <div className={styles.userInfo}>
                            <div className={styles.userName} onClick={() => userClick && userClick()}>{userData?.nickname || userData?.username || '未命名用户'}
                                {userData?.gender === 2 && <img src={`${BASE_IMG_URL}/common/woman.png`} alt="性别" className={styles.gender}/>}
                                {userData?.gender === 1 && <img src={`${BASE_IMG_URL}/common/man.png`} alt="性别" className={styles.gender}/>}
                            </div>

                            {userData?.lastPublishSource != '' && <div className={styles.model}>{userData?.lastPublishSource || ''}</div>}
                            <div className={styles.userTagBox}>
                                {userData?.titleList?.length > 0 ? userData?.titleList?.map((item: any, idx: number) => (
                                    <div className={styles.userTag} key={idx}>{item.title_name}</div>
                                )) : null}
                            </div>
                            <div className={styles.userBrief}>{userData?.signature || '欢迎来到vivo社区，快来介绍下自己吧'}</div>
                        </div>
                    </div>}
                    <div className={styles.dataCountBox}>
                        <div className={styles.dataCountItem}>
                            <div className={styles.dataCount}>{formatNumberToWan(userData?.getLikedCount ?? 0)}</div>
                            <div className={styles.dataType}>获赞</div>
                        </div>
                        {!showOtherInfo && <div className={styles.dataCountItem}>
                            <div className={styles.dataCount}>{formatNumberToWan(userData?.threadCount ?? 0)}</div>
                            <div className={styles.dataType}>帖子</div>
                        </div>}
                        <div className={styles.dataCountItem}>
                            <div className={styles.dataCount}>{formatNumberToWan(userData?.followCount ?? 0)}</div>
                            <div className={styles.dataType}>关注</div>
                        </div>
                        <div className={styles.dataCountItem}>
                            <div className={styles.dataCount}>{formatNumberToWan(userData?.fansCount ?? 0)}</div>
                            <div className={styles.dataType}>粉丝</div>
                        </div>
                        {!showOtherInfo && <div className={styles.dataCountItem}>
                            <div className={styles.dataCount}>{formatNumberToWan(userData?.score ?? 0)}</div>
                            <div className={styles.dataType}>V币</div>
                        </div>}
                    </div>
                    {!isFeedback && <div
                        className={styles.publishBtn}
                        onClick={(e) => {
                            if(!isLogin) {
                                loginClick && loginClick()
                                return false;
                            }
                            e.stopPropagation();
                            publishClick && publishClick();
                        }}
                    >{topicId === '' ? '发图文' : '参与话题讨论'}</div>}
                    {isFeedback && <div>
                        <div className={styles.feedbackPublishBtn} onClick={() => {
                            this.props.history && this.props.history.push(`/setFeedbackPost`);
                        }}>我要反馈</div>
                        <div className={styles.myFeedbackLink} onClick={() => {
                            this.props.history && this.props.history.push(`/user/${user?.userInfo?.code}?tab=5`);
                        }}>我的反馈</div>
                    </div>}
                </>}

                {/* 未登录 */}
                {(!isLogin && !showOtherInfo) && <div className={styles.noLoginBox}  onClick={() => {
                        
                    }}>
                    <Avatar size={65} userCode={0}></Avatar>
                    <div className={styles.noLogin}>未登录</div>
                    <div className={styles.loginTip}>快登录分享你的想法吧</div>
                    <div
                        className={styles.publishBtn}
                        onClick={(e) => {
                            e.stopPropagation();
                            loginClick && loginClick();
                        }}
                    >登录</div>
                </div>}
            </div>
        </>;

    }
}

export default withRouter(PCSidebarUserInfo);
